export default "https://cdn-static.gokick.com/assets/1a6b0e419037e7f05bc52ad73a019b5bb7bc4745/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";